import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { IonReorderGroup, ModalController, LoadingController, ToastController } from '@ionic/angular';
import { ItemReorderEventDetail } from '@ionic/core';

import { Stylist } from '../../../../models/stylist/stylist.model';
import { ServiceCategory } from '../../../../models/service-category/service-category.model';
import { ServiceDefinition } from '../../../../models/service-definition/service-definition.model';
import { UserService } from '../../../../services/user.service';
import { ServiceCategoryService } from '../../../../services/service-category.service';
import { Utilities } from '../../../../utilities/utilities';

import { List } from 'immutable';

import { AlertService } from '../../../../utilities/alert.service';
import { ServiceCategoryFormComponent } from '../../service-category-form/service-category-form.component';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AllStylistServiceAddCategoryPage } from '../all-stylist-service-add-category/all-stylist-service-add-category.page';

import { NavigationStateService } from '../../../../services/navigation-state.service';
declare var posthog: any;

@Component({
  selector: 'smr-all-stylist-service-manager',
  templateUrl: './all-stylist-service-manager.component.html',
  styleUrls: ['./all-stylist-service-manager.component.scss'],
})
export class AllStylistServiceManagerComponent implements OnInit {
  @Input() stylist: Stylist;
  @ViewChild(IonReorderGroup) reorderGroup: IonReorderGroup;
  public isLoading: boolean;

  public errorOccurredWhileLoadingServices: boolean;

  public salonServiceCategories: List<ServiceCategory>;

  public salonServiceCategoriesForReordering: List<ServiceCategory>;
  public serviceCategoryForm: UntypedFormGroup;
  public serviceCategoryField: UntypedFormControl;
  public serviceCategory: ServiceCategory = new ServiceCategory({
    id: 0,
    categoryName: null,
    serviceDefinitions: null,
  });


  public planID: number;

  // 'normal' | 'reodercategories' | 'reoderservices'
  public viewMode: string = 'normal';

  public isServicesReordering: boolean = false;

  public isServiceCategoriesReordering: boolean = false;

  constructor(private modalCtrl: ModalController,
    private userService: UserService,
    private toastController: ToastController,
    private serviceCategoryService: ServiceCategoryService,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private navigationStateService: NavigationStateService
  ) {
    this.salonServiceCategories = List([]);
    this.salonServiceCategoriesForReordering = List([]);
    this.isLoading = true;
  }

  public ngOnInit() {
    this.loadServices();
    this.planID = this.userService.getSalon().planID;
  }


  public loadServices() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingServices = false;
    this.serviceCategoryService.getSalonServiceCategories()
      .subscribe({
        next: (salonServiceCategories) => {
          this.salonServiceCategories = salonServiceCategories;
          this.isLoading = false;
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingServices = true;
        }
      });
  }

  public onAddAction() {
    const newServiceDefinition = new ServiceDefinition({
      id: undefined,
      parentID: undefined,
      categoryID: undefined,
      name: '',
      duration: 15,
      processDuration: 0,
      finishDuration: 0,
      price: 0,
      clientBookable: 1,
      stylist: undefined,
      description: '',
      startingAt: 0,
      serviceCategory: undefined
    });
    this.navigationStateService.setState({
    
      service: newServiceDefinition,
      salonServiceCategories: this.salonServiceCategories,
    });
    this.router.navigate(["settings/services/manager/all-stylist-service-form"]);
  }

  public async onServiceCategorySelect(serviceCategory: ServiceCategory) {
    const modal = await this.modalCtrl.create({
      component: ServiceCategoryFormComponent,
      componentProps: { serviceCategory: serviceCategory }
    });
    modal.onDidDismiss().then((serviceCategory: any) => {
      if (serviceCategory.data) {
        this.loadServices();
      }
    });
    return await modal.present();
  }

  public editSalonService(serviceDefinition: ServiceDefinition, $event?) {

    if ($event) {
      $event.stopPropagation();
    }

    new Promise((resolve, reject) => {
      /*this.navController.push("AllStylistServiceFormPage", {
        service: serviceDefinition,
        salonServiceCategories: this.salonServiceCategories,
        callbackFn: resolve
      });*/
      posthog.capture('$pageview');



    this.navigationStateService.setState({
      service: serviceDefinition,
      salonServiceCategories: this.salonServiceCategories,
    });

      this.router.navigate(["settings/services/manager/all-stylist-service-form"]);

    })
      .then((id: number) => {
        if (id) {
          this.loadServices();
        }
      });


    // const modal = this.modalCtrl.create("AllStylistServiceFormPage", {
    //   service: serviceDefinition,
    //   salonServiceCategories: this.salonServiceCategories
    // },
    // {enableBackdropDismiss: false});

    // modal.onDidDismiss((serviceDefintion: ServiceDefinition) => {
    //   if (serviceDefintion) {
    //     this.loadServices();
    //   }
    // });

    // modal.present();
  }

  public onMoreAction() {
  }

  public enableServiceCategoriesReordering() {
    this.isServiceCategoriesReordering = true;
    this.isServicesReordering = false;
    this.salonServiceCategoriesForReordering = this.salonServiceCategories;
    this.viewMode = 'reorder-categories';
  }
  public async enableAddCategory() {
    const modal = await this.modalCtrl.create({
      component: AllStylistServiceAddCategoryPage,
    });
    modal.onDidDismiss().then((serviceCategory: any) => {
      if (serviceCategory.data) {
        this.loadServices();
      }
    });
    return await modal.present();
    this.router.navigate(["settings/services/manager/all-stylist-service-add-category"]);
  }
  public enableServicesReordering() {
    this.isServicesReordering = true;
    this.isServiceCategoriesReordering = false;
    this.salonServiceCategoriesForReordering = this.salonServiceCategories;
    this.viewMode = 'reorder-services';
  }
  getCategoryName(): string {
    return this.serviceCategory.getCategoryName();
  }


  public onCancelOrderMode() {
    this.viewMode = 'normal';
  }

  public reorderServiceCategories($event: CustomEvent<ItemReorderEventDetail>) {
    const element = List(this.salonServiceCategoriesForReordering).get($event.detail.from);
    this.salonServiceCategoriesForReordering = this.salonServiceCategoriesForReordering.splice($event.detail.from, 1).toList();
    this.salonServiceCategoriesForReordering = this.salonServiceCategoriesForReordering.splice($event.detail.to, 0, element).toList();
    $event.detail.complete();
  }

  public reorderServices($event: CustomEvent<ItemReorderEventDetail>, serviceCategoryIndex: number) {
    let serviceCategory = this.salonServiceCategoriesForReordering.get(serviceCategoryIndex);
    let serviceDefinitions = List(serviceCategory.getServiceDefinitions());

    const element = serviceDefinitions.get($event.detail.from);
    serviceDefinitions = serviceDefinitions.splice($event.detail.from, 1).toList();
    serviceDefinitions = serviceDefinitions.splice($event.detail.to, 0, element).toList();

    serviceCategory = serviceCategory.setServiceDefinitions(serviceDefinitions);
    this.salonServiceCategoriesForReordering = this.salonServiceCategoriesForReordering.set(serviceCategoryIndex, serviceCategory).toList();
  }

  public async onSaveOrder() {
    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });
    this.serviceCategoryService.saveServiceSort(this.salonServiceCategoriesForReordering)
      .subscribe({
        next: () => {
          loader.dismiss().then(async () => {
            this.isServiceCategoriesReordering = false;
            this.isServicesReordering = false;
            const toast = await this.toastController.create({
              message: `You services have been successfully saved.`,
              duration: 3000,
            });
            toast.present();

            this.salonServiceCategories = this.salonServiceCategoriesForReordering;
            this.viewMode = 'normal';
          })
        },
        error: (e) => {
          loader.dismiss().then(async () => {
            const toast = await this.toastController.create(Utilities.getDefaultErrorMessageConfig())
            toast.present();
            this.alertService.presentErrorAlert();
          });
        }
      });

  }

  // public reorderServices ($event: { from: number, to: number}) {
  //   let serviceCategortIndex: number = 0;
  //   let itemIndex: number = 0;
  //   let element: ServiceDefinition;

  //   this.salonServiceCategoriesForReordering.some((serviceCategory) => {
  //     const serviceCount = serviceCategory.getServiceDefinitions().count();

  //     if ($event.from <= (itemIndex + serviceCount)) {
  //       const index = $event.from - (itemIndex + 1);
  //       element = this.salonServiceCategoriesForReordering.get(serviceCategortIndex).getServiceDefinitions().get(index);

  //       const serviceDefinitions = serviceCategory.getServiceDefinitions().splice(index, 1).toList();
  //       serviceCategory = serviceCategory.setServiceDefinitions(serviceDefinitions);
  //       this.salonServiceCategoriesForReordering = this.salonServiceCategoriesForReordering.set(serviceCategortIndex, serviceCategory);
  //       return true;
  //     }

  //     serviceCategortIndex++;

  //     // add 1 to the serviceCount to account for serviceCategory increase?
  //     itemIndex += (serviceCount + 1);
  //   });


  //   serviceCategortIndex = 0;
  //   itemIndex = 0;


  //   if ($event.from < $event.to) {
  //     $event.to = $event.to - 1;      
  //   }

  //   this.salonServiceCategoriesForReordering.some((serviceCategory) => {
  //     const serviceCount = serviceCategory.getServiceDefinitions().count();

  //     if ($event.to <= (itemIndex + serviceCount)) {
  //       let index = $event.to - (itemIndex + 1);

  //       const serviceDefinitions = serviceCategory.getServiceDefinitions().splice(index, 0, element).toList();
  //       serviceCategory = serviceCategory.setServiceDefinitions(serviceDefinitions);
  //       this.salonServiceCategoriesForReordering = this.salonServiceCategoriesForReordering.set(serviceCategortIndex, serviceCategory);
  //       return true;
  //     }

  //     serviceCategortIndex++;

  //     // add 1 to the serviceCount to account for serviceCategory increase?
  //     itemIndex += (serviceCount + 1);
  //   });

  // }


}
